import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { FYIConfig } from '../types/fyi-docs';

type GetFYIConfigResponse = {
    config?: FYIConfig;
};
async function getFYIConfig(): Promise<GetFYIConfigResponse> {
    const { data } = await api.get('/fyi-docs/configuration');
    return data;
}

export function useFYIConfig(): UseQueryResult<GetFYIConfigResponse, unknown> {
    return useQuery(['fyi', 'configuration'], () => getFYIConfig(), {
        keepPreviousData: true,
    });
}
